export default __webpack_public_path__ + "static/media/comingsoon.e3849102.png";